import React, { useContext } from "react";
import AppContext from "AppContext";
import { hasElements } from "utils/arrays";
import { TextField, MenuItem } from "@material-ui/core";
import CalendarContext from "../CalendarContext";

function Filters() {
    const { filters, setFilters } = useContext(CalendarContext);
    const { allowedModules } = useContext(AppContext);

    function onSelectModuleChange(event) {
        const newModule = event.target && event.target.value;
        setFilters((prev) => ({ ...prev, module: newModule }));
    }

    function getModuleOptions() {
        let options = [{ value: "all", label: "All modules" }];
        if (hasElements(allowedModules)) {
            options = [...options, ...allowedModules.map((m) => ({ value: m.code, label: m.name }))];
        }
        return options;
    }

    return (
        <TextField select variant="standard" onChange={onSelectModuleChange} value={filters.module} fullWidth size="small" margin="dense">
            {getModuleOptions().map(({ value, label }, index) => (
                <MenuItem key={index} value={value}>
                    {label}
                </MenuItem>
            ))}
        </TextField>
    );
}

export default Filters;
